module.exports = __webpack_public_path__ + "img/pt-3.99351262.jpg";